import React from 'react';
import {Redirect} from 'react-router-dom';

import {SiteHardPassword as SiteHardPasswordService} from 'Services';

/**
 * @function SiteHardPassword
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
const SiteHardPassword = ({component}) => {
    if (!window.base.using_site_hard_password) {
        return component;
    }
    
    const auth = SiteHardPasswordService.authed;

    return auth ? component : <Redirect to="/site-hard-password" />;
};

export default SiteHardPassword;